<script setup>
import { getCurrentInstance, onMounted, ref, onBeforeUnmount } from "vue";
import { store as storeConfig } from "~app_root/public/tv/app.config";
import { Link } from '@inertiajs/vue3'
import { scrollTop } from "@/utility";
import { useCartItem } from "@/Composables/useCartItem";

const appInstance = getCurrentInstance();
const emitter = appInstance.appContext.config.globalProperties.emitter;

const props = defineProps({
	data: {
		type: Object,
		required: true
	}
});

// Current image index
const currentImageIndex = ref(0);
// Transition interval
let transitionInterval;

// Returns a random interval between 3000ms and 7000ms for image transitions
const getRandomInterval = () => {
	return Math.floor(Math.random() * (7000 - 3000 + 1) + 3000);
};

// Updates the current image index to the next image in the array
const nextImage = () => {
	currentImageIndex.value = (currentImageIndex.value + 1) % props.data.images.length;
};

// Sets up the transition interval when the component is mounted
onMounted(() => {
	if (props.data.images.length > 1) {
		transitionInterval = setInterval(nextImage, getRandomInterval());
	}
});

// Clears the transition interval when the component is unmounted
onBeforeUnmount(() => {
	if (transitionInterval) {
		clearInterval(transitionInterval);
	}
});
</script>

<template>
	<div class="grid-integrated-promotion">
		<div>
			<div class="image-container">
				<transition-group name="fade" tag="div" class="images-wrapper">
					<template v-for="(image, index) in data.images" :key="image.id || index">
						<a v-if="image.data?.action?.name === 'openUrl'" :href="image.data.action.url"
							class="image-link" :class="{ 'active': index === currentImageIndex }">
							<img :src="image.name" :alt="image.alt || 'Promotie'" class="promotion-image">
						</a>
						<div v-else class="image-link" :class="{ 'active': index === currentImageIndex }">
							<img :src="image.name" :alt="image.alt || 'Promotie'" class="promotion-image">
						</div>
					</template>
				</transition-group>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "GIP"
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
</style>